import { mask, unmask } from "remask";

export function maskCellphone(value: string) {
  const unmaskedValue = unmask(value)
  return unmaskedValue.length < 3
    ? unmaskedValue
    : mask(value, '(99) 99999-9999')
}
